import React from 'react'
import Navbar from '../navbar/navbar'
import Skills from '../skills/skill'

const Skillspage = () => {
  return (
    <div>
      <Navbar/>
      <Skills/>
    </div>
  )
}

export default Skillspage
